export const systemCycleOptions = [
    { value: 'Configured', label: 'Configured'},
    { value: 'Linked to Device', label: 'Linked to Device'},
    { value: 'Commissioned - Learning', label: 'Commissioned - Learning'},
    { value: 'Commissioned - In Service', label: 'Commissioned - In Service'},
    { value: 'Commissioned - Not Monitored', label: 'Commissioned - Not Monitored'},
    { value: 'Internal Use', label: 'Internal Use' },
    { value: 'Decommissioned', label: 'Decommissioned'},
    { value: 'Commissioned, Water Meter not tested', label: 'Commissioned, Water Meter not tested'},
    { value: 'System in TSO', label: 'System in TSO'},
    { value: 'Installation Canceled', label: 'Installation Canceled'},
];

export const defaultSystemStates = [
    {
        "value": "Commissioned - Learning",
        "label": "Commissioned - Learning"
    },
    {
        "value": 'Commissioned - In Service',
        "label": 'Commissioned - In Service'
    },
    {
        "value": 'Commissioned, Water Meter not tested',
        "label": 'Commissioned, Water Meter not tested'
    },
];
